import React from 'react';
import { WORKFLOW_TYPE_LINK_ACCOUNT } from 'helpers/registrationWorkflow';
import {
  searchWithoutUsername,
  searchWithUsernameHint,
  rawSearchHasNonEmptyUsername,
} from 'helpers/preserveQueryString';
import { Link, useLocation } from 'react-router-dom';
import { Button } from 'reactstrap';

function primaryLoginIdFromFields(registrationFields) {
  const rf = registrationFields || {};
  const fromSelection = String(
    rf.selectedPrimaryEmail || rf.selectedPrimaryPhone || '',
  ).trim();
  if (fromSelection) return fromSelection;
  // New signup without SelectPrimaryLogin (e.g. IsMobileNumberRequiredForLinking false)
  // only carries `email` on location.state — use it for OAuth Continue / Sign In hint.
  return String(rf.email || '').trim();
}

const Success = ({ registrationFields, workflowType }) => {
  const { code } = registrationFields || {};
  const { search: routerSearch } = useLocation();
  const rawSearch =
    routerSearch ||
    (typeof window !== 'undefined' ? window.location.search : '') ||
    '';
  const params = new URLSearchParams(rawSearch);
  const primaryLoginId = primaryLoginIdFromFields(registrationFields);
  const hadUsernameInUrl = rawSearchHasNonEmptyUsername(rawSearch);

  const oauthSearchWithoutUsername = searchWithoutUsername(rawSearch);
  const loginHintState = primaryLoginId ? { username: primaryLoginId } : undefined;

  const toLogin = {
    pathname: '/login',
    search:
      primaryLoginId && hadUsernameInUrl
        ? searchWithUsernameHint(rawSearch, primaryLoginId)
        : rawSearch,
    state: loginHintState,
  };

  const toAuthorize = {
    pathname: '/account/authorize',
    search:
      primaryLoginId && hadUsernameInUrl
        ? searchWithUsernameHint(rawSearch, primaryLoginId)
        : oauthSearchWithoutUsername,
    state: loginHintState,
  };

  const responseType = params.get('response_type');
  const redirectUri = params.get('redirect_uri');

  const handleLinkingContinue = () => {
    if (redirectUri && code) {
      const linkParams = new URLSearchParams(rawSearch);
      linkParams.delete('client_id');
      linkParams.delete('redirect_uri');
      linkParams.delete('response_type');
      linkParams.delete('firstname');
      linkParams.delete('lastname');
      linkParams.delete('username');
      const queryString = linkParams.toString();
      if (queryString) {
        window.location.href = `${redirectUri}?retrieval_code=${code}&${queryString}`;
      } else {
        window.location.href = `${redirectUri}?retrieval_code=${code}`;
      }
    }
  };

  return (
    <div>
      <h2 className="AuthWrapper__content-headline">
        {workflowType === WORKFLOW_TYPE_LINK_ACCOUNT
          ? 'Success! Your Account has been linked.'
          : 'Success! You have registered.'}
      </h2>
      {workflowType !== WORKFLOW_TYPE_LINK_ACCOUNT && (
        <div className="AuthWrapper__content-message">
          <p>You can sign in on the next screen.</p>
        </div>
      )}
      <div className="AuthWrapper__content-action">
        {workflowType === WORKFLOW_TYPE_LINK_ACCOUNT ? (
          <Button
            id="linkingSuccess"
            color="primary"
            block
            onClick={handleLinkingContinue}
          >
            Continue
          </Button>
        ) : responseType === 'code' ? (
          <Link to={toAuthorize}>
            <Button id="registerSuccess" color="primary" block>
              Continue
            </Button>
          </Link>
        ) : (
          <Link to={toLogin}>
            <Button id="registerSuccess" color="primary" block>
              Continue
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Success;
